import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyCjeKES7DKa-uca1NIUSyE87x7xCKeAJGg",
    authDomain: "open-96133.firebaseapp.com",
    databaseURL: "https://open-96133.firebaseio.com",
    projectId: "open-96133",
    storageBucket: "open-96133.appspot.com",
    messagingSenderId: "24739423158",
    appId: "1:24739423158:web:83018a2980321cf91f5717",
    measurementId: "G-XYBL52Z1HF"
};

firebase.initializeApp(firebaseConfig)
// const storage = firebase.storage().ref();
const storage = firebase.storage();
const deleteObject = storage.dele
export { firebase, storage as default };
